import { StoryData } from '@cinch-nx/data-storyblok'
import { CollectionLocationStory } from '../storyblok'

export const collectionLocationFallbackStory: StoryData<CollectionLocationStory> =
  {
    name: 'collection-location',
    created_at: '2026-06-23T14:19:12.492Z',
    published_at: '2026-06-24T09:10:31.826Z',
    id: 190_606_346_244_431,
    uuid: '9dc92e9b-fdcf-48f6-b869-aa603a3b8b07',
    content: {
      SEO: [],
      _uid: '79ddaff3-1fb8-4d50-b812-5b11f559d007',
      body: [
        {
          _uid: '8215e1a9-7372-41a4-8707-a2418a992946',
          component: 'SiteLocation',
          emailLabel: 'Email us at:',
          phoneLabel: 'Call us on:',
          contactUsEmailAddress: 'hello@cinch.co.uk',
          contactUsTelephoneNumber: '0333 015 4101',
          _editable:
            '\u003C!--#storyblok#{"name": "SiteLocation", "space": "143588", "uid": "8215e1a9-7372-41a4-8707-a2418a992946", "id": "190606346244431"}--\u003E',
        },
        {
          _uid: '9f30a072-fb51-4e1b-b50a-8451fbd6a846',
          title: 'Nearby collection locations',
          component: 'NearbyLocations',
          cardButtonText: 'Find out more',
          _editable:
            '\u003C!--#storyblok#{"name": "NearbyLocations", "space": "143588", "uid": "9f30a072-fb51-4e1b-b50a-8451fbd6a846", "id": "190606346244431"}--\u003E',
        },
        {
          _uid: 'dc40ea99-7b76-4187-826d-1c1f63238327',
          text: 'Search for another collection location.',
          image: [
            {
              alt: '2 people on a sofa browsing on a tablet device',
              _uid: '10793c59-2357-4931-8073-0ff674aab271',
              image: {
                id: 190_884_190_987_649,
                alt: '2 people on a soa browsing on a tablet device',
                name: '',
                focus: '',
                title: '',
                source: '',
                filename:
                  'https://a.storyblok.com/f/143588/599x403/77bca30194/people-browsing-on-the-tablet.avif',
                copyright: '',
                fieldtype: 'asset',
                meta_data: {
                  alt: '2 people on a sofa browsing on a tablet device',
                  title: '',
                  source: '',
                  copyright: '',
                },
                is_external_url: false,
              },
              component: 'Image',
              _editable:
                '\u003C!--#storyblok#{"name": "Image", "space": "143588", "uid": "10793c59-2357-4931-8073-0ff674aab271", "id": "190606346244431"}--\u003E',
            },
          ],
          heading: ' ',
          iconName: 'home-delivery',
          component: 'SectionWithImageV2',
          iconColor: 'goGreen',
          buttonLabel: 'Search again',
          headingColor: '#8DFFBE',
          backgroundColor: '#5234B6',
          _editable:
            '\u003C!--#storyblok#{"name": "SectionWithImageV2", "space": "143588", "uid": "dc40ea99-7b76-4187-826d-1c1f63238327", "id": "190606346244431"}--\u003E',
        },
        {
          _uid: '0651fab2-4963-40c3-8cb5-32c3c15a553c',
          title: 'Ready to hit the open road?',
          iconName: 'search',
          subtitle: "Let's find your next car",
          component: 'PreFooterCtaV2',
          buttonLabel: 'Search all cars',
          iconGradient: 'galaxy',
          _editable:
            '\u003C!--#storyblok#{"name": "PreFooterCtaV2", "space": "143588", "uid": "0651fab2-4963-40c3-8cb5-32c3c15a553c", "id": "190606346244431"}--\u003E',
        },
      ],
      hero: [
        {
          _uid: '4e11ebcd-1948-4554-bcc3-13267e289ff5',
          body: 'Just book your 2-hour time slot at checkout and one of our cinch handover specialists will meet you there.',
          image: {
            id: 190_609_587_153_232,
            alt: 'a person delivering a car to a front door',
            name: '',
            focus: '',
            title: '',
            source: '',
            filename:
              'https://a.storyblok.com/f/143588/1200x857/908551c0f7/collection-location-delivery.webp',
            copyright: '',
            fieldtype: 'asset',
            meta_data: {
              alt: 'a person delivering a car to a front door',
              title: '',
              source: '',
              copyright: '',
            },
            is_external_url: false,
          },
          title: '',
          component: 'GenericHero',
          _editable:
            '\u003C!--#storyblok#{"name": "GenericHero", "space": "143588", "uid": "4e11ebcd-1948-4554-bcc3-13267e289ff5", "id": "190606346244431"}--\u003E',
        },
      ],
      component: 'LandingPage',
      _editable:
        '\u003C!--#storyblok#{"name": "LandingPage", "space": "143588", "uid": "79ddaff3-1fb8-4d50-b812-5b11f559d007", "id": "190606346244431"}--\u003E',
    },
    slug: 'collection-location',
    full_slug: 'collection-location',
    sort_by_date: null,
    position: -310,
    tag_list: [],
    is_startpage: false,
    parent_id: 0,
    meta_data: null,
    group_id: '32ff4808-5088-4b8c-9e69-955d12c14810',
    first_published_at: '2026-06-24T09:03:14.720Z',
    lang: 'default',
    alternates: [],
  }
